module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back kaoji-box",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "kaoji-title"
  }, [_vm._v(_vm._s(_vm.row.danwei) + _vm._s(_vm.row.kaojitype))]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "单位名称",
      "value": _vm.row.shenbaodanwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "所属区域",
      "value": _vm.areaValue
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "负责人",
      "value": _vm.row.nickname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "是否授牌",
      "value": _vm.row.jindu == 6 ? '是' : '否'
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "俱乐部编号",
      "value": _vm.row.bcode ? _vm.row.bcode : '无'
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c928c7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubDetailBase.vue
// module id = 2280
// module chunks = 0